export const existsAndNotNull = (x) => x != null;
